import { VerifyFlow } from '@/features/verify/VerifyFlow';

export function VerifyPage() {
  return <VerifyFlow />;
}
